export default [
  {
    code: 'code',
    name: 'code',
    type: 'id',
    required: false,
  },
  {
    code: 'name',
    name: 'name',
    type: 'input',
    required: true,
  },
  {
    code: 'shortName',
    name: 'short_name',
    type: 'input',
    required: true,
  },
  {
    code: 'description',
    name: 'description',
    type: 'input',
  },
]
